var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},[_c('navBar')],1),_c('div',{attrs:{"id":"cont"}},[_c('router-view')],1),_c('div',{attrs:{"id":"footer"}},[_c('foot')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }